import { Link } from 'react-router-dom';
import logo from '../assets/img/logo.png';
// import logo from '../assets/img/logo-1.png';

export const IndexNav = () => {
    return (
        <nav className="navbar navbar-expand-lg bg-light text-uppercase fixed-top" id="mainNav">
        <div className="container">
            <Link className="navbar-brand d-flex" to="/web">
                <img src={logo} alt='Logo' width={100} />
            </Link>
            <button className="navbar-toggler shadow-none" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                <i className="fas fa-bars fs-5 mt-1"></i>
            </button>
            <div className="collapse navbar-collapse" id="navbarResponsive">
                <ul className="navbar-nav mx-auto">
                    {/* <li className="nav-item mx-0 mx-lg-1"><a className="nav-link py-3 px-0 px-lg-3 rounded" href="#products">Products</a></li> */}

                    <li className="nav-item dropdown">
                        <a className="nav-link py-3 px-0 px-lg-3 rounded dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Products</a>
                        <ul className="dropdown-menu">
                            <li className="nav-item dropdown dropend pc-dropdown">
                                <a className="dropdown-item dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Payment Collection</a>
                                <ul className="dropdown-menu">
                                    <li>
                                        <a className="dropdown-item" href="#apibc">Api Based Collection</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#linkbc">Portal/Link Based Collection</a>
                                    </li>
                                </ul>
                            </li>
                            {/* <li className="nav-item dropdown dropend pc-dropdown">
                                <a className="dropdown-item dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Payout</a>
                                <ul className="dropdown-menu">
                                    <li>
                                        <a className="dropdown-item" href="#footer">Up Coming</a>
                                    </li>
                                </ul>
                            </li> */}
                        </ul>
                    </li>

                    <li className="nav-item mx-0 mx-lg-1"><a className="nav-link py-3 px-0 px-lg-3 rounded" href="#about">About</a></li>
                    <li className="nav-item mx-0 mx-lg-1"><a className="nav-link py-3 px-0 px-lg-3 rounded" href="#contact">Contact</a></li>
                </ul>
                <ul className="navbar-nav signbtn-menu mt-0">
                    {/* <li className="nav-item mx-0 mx-lg-1"><Link className="nav-link py-3 px-0 px-lg-3 rounded" to="/login">Signup / Signin</Link></li> */}
                </ul>
            </div>
            <ul className="navbar-nav signbtn">
                {/* <li className="nav-item mx-0 mx-lg-1"><Link className="nav-link py-3 px-0 px-lg-3 rounded" to="/login">Signup / Signin</Link></li> */}
            </ul>
        </div>
        </nav>
    )
}

export const IndexFooter = () => {
    return (<>
    <footer className="pt-4 pb-3 text-center bg-light">
        <div className="container">
            <div className='row'>
                <div className='col-md-4 mb-3'>
                    <img src={logo} alt='Logo' width={150} />
                </div>
                <div className='col-md-4 mb-3'>
                    <div className='h-100 d-flex align-items-center justify-content-center'>
                    <p className='mb-0 text-secondary'>Copyright &copy; Your Website 2023</p>
                    </div>
                </div>
                <div className='col-md-4 mb-3'>
                    <ul className='list-unstyled mb-0'>
                        <li><Link to='/termscondition'>Terms and Conditions</Link></li>
                        <li><Link to='/privacypolicy'>Privacy Policy</Link></li>
                    </ul>
                </div>
            </div>

        </div>
    </footer> 

    </>)
}